import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_ENDPOINTS, API_BASE_URL } from "../config/api";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  
  // Инициализация email из location.state или из sessionStorage
  React.useEffect(() => {
    const stateEmail = location.state?.email;
    const storedEmail = sessionStorage.getItem('resetPasswordEmail');
    
    if (stateEmail) {
      setEmail(stateEmail);
      sessionStorage.setItem('resetPasswordEmail', stateEmail);
    } else if (storedEmail) {
      setEmail(storedEmail);
    }
  }, [location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Email не найден. Вернитесь к предыдущему шагу.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Пароли не совпадают");
      return;
    }

    if (newPassword.length < 6) {
      setError("Пароль должен содержать минимум 6 символов");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await fetch(API_ENDPOINTS.RESET_PASSWORD, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          code,
          newPassword,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Пароль успешно изменен! Теперь вы можете войти.");
        // Переходим на страницу входа
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        setError(data.error || "Произошла ошибка при сбросе пароля");
      }
    } catch (err) {
      setError("Произошла ошибка сети. Попробуйте еще раз.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    if (!email) return;

    try {
      const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setMessage("Новый код отправлен на вашу почту");
        setTimeout(() => setMessage(""), 3000);
      }
    } catch (err) {
      setError("Ошибка при повторной отправке кода");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Сброс пароля</h2>
        {email ? (
          <p className="auth-description">
            Введите код, который мы отправили на <strong>{email}</strong>
          </p>
        ) : (
          <p className="auth-description">
            Введите ваш email и код восстановления
          </p>
        )}

        <form onSubmit={handleSubmit}>
          {!email && (
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                placeholder="Введите ваш email"
              />
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="code">Код восстановления:</label>
            <input
              type="text"
              id="code"
              name="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              disabled={loading}
              placeholder="Введите 8-значный код"
              maxLength="8"
              pattern="[0-9]{8}"
            />
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">Новый пароль:</label>
            <input
              type="password"
              id="newPassword"
              name="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              disabled={loading}
              placeholder="Введите новый пароль"
              minLength="6"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Подтвердите пароль:</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={loading}
              placeholder="Повторите новый пароль"
              minLength="6"
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          <button
            type="submit"
            disabled={loading || !code || !newPassword || !confirmPassword}
            className="auth-button"
          >
            {loading ? "Сбрасываем..." : "Сбросить пароль"}
          </button>
        </form>

        <div className="auth-links">
          <button
            onClick={handleResendCode}
            className="link-button"
            disabled={loading}
          >
            Отправить код повторно
          </button>
          <button onClick={() => navigate("/login")} className="link-button">
            Вернуться к входу
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
